module.exports = __webpack_public_path__ + "static/media/down-arrow-grey.10c3dab2.svg";